// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "@media screen and (max-width: 1366px) {\n.block-title__content[data-v-469b6949] {\n    font-size: 1rem;\n}\n}\n", "",{"version":3,"sources":["/app/src/components/block_title/style_notebook.less"],"names":[],"mappings":"AAAA;AAEC;IACC,eAAA;AAAA;AACF","file":"style_notebook.less","sourcesContent":["@media screen and (max-width: 1366px) {\n\n\t.block-title__content {\n\t\tfont-size: 16px;\n\t}\n\n}\n"]}]);
// Exports
module.exports = exports;
